import { DEFAULT_ELEMENT_MULTIPLIER } from "common/constants";
import type { ElementInspectorFormValues } from "./types";

export const FORM_DEFAULT_VALUES: ElementInspectorFormValues = {
  bbox: { x1: 0, y1: 0, x2: 0, y2: 0 },
  group_id: "",
  multiplier: DEFAULT_ELEMENT_MULTIPLIER,
  note: "",
};
